/*
 * Jira Ticket:
 * Created Date: Wed, 25th Mar 2020, 12:03:45 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { NumberInput, SelectInput, TextInput } from 'react-admin';
import { columnStyles } from 'styles';
import { isQualifiedOptions, towerEnvironmentOptions } from 'utils/choices';

const TowerDetailTab = ({ basePath, formValues, permissions, ...props }) => {
  const classes = columnStyles();

  return (
    <div>
      <div className={classes.root}>
        <div className={classes.column}>
          <TextInput
            source="tower.id"
            label={'resources.Inspection.fields.towerId'}
            disabled={true}
          />
          <TextInput
            source="tower.builder.name"
            label={'resources.Inspection.fields.builderName'}
            disabled={true}
          />
          <TextInput
            source="tower.tag"
            label={'resources.Inspection.fields.recordTag'}
            disabled={true}
          />
          <NumberInput
            source="tower.site.location.lat"
            label={'resources.Inspection.fields.latitude'}
            disabled={true}
          />
          <TextInput
            source="tower.builder.certificateNumber"
            disabled={true}
            label={'resources.Inspection.fields.certNum'}
          />
        </div>
        <div className={classes.column}>
          <TextInput
            source="tower.site.project.organisation.name"
            disabled={true}
            label={'resources.Inspection.fields.organisation'}
          />
          <TextInput
            source="tower.type.name"
            disabled={true}
            label={'resources.Inspection.fields.towerType'}
          />
          <TextInput
            source="tower.site.name"
            disabled={true}
            label={'resources.Inspection.fields.site'}
          />
          <NumberInput
            source="tower.site.location.lng"
            label={'resources.Inspection.fields.longitude'}
            disabled={true}
          />
        </div>
        <div className={classes.column}>
          <TextInput
            source="tower.site.project.name"
            disabled={true}
            label={'resources.Inspection.fields.project'}
          />
          <SelectInput
            source="tower.builderQualified"
            disabled={true}
            label={'resources.Inspection.fields.qualificationStatus'}
            choices={isQualifiedOptions}
          />
          <TextInput
            source="tower.platformHeight"
            disabled={true}
            format={height => height && `${height}m`}
            label={'resources.Inspection.fields.platformHeight'}
          />
          <SelectInput
            source="tower.environment"
            disabled={true}
            label={'resources.Inspection.fields.environment'}
            choices={towerEnvironmentOptions}
          />
        </div>
      </div>
      <TextInput
        source="tower.notes"
        disabled={true}
        multiline={true}
        fullWidth
        label={'resources.Inspection.fields.notes'}
      />
    </div>
  );
};

export default TowerDetailTab;
